import React from 'react'
import { ThemeProvider as EmotionThemeProvider } from 'emotion-theming'
import { theme } from 'src/styles/theme'

const ThemeProvider: React.FunctionComponent = ({ children }) => (
  <EmotionThemeProvider theme={theme}>{children}</EmotionThemeProvider>
)

export default ThemeProvider
